import { filterStoreRepo } from 'components/Filters/FilterStore'
import FilterModal, {
  FilterGroup,
} from 'components/Filters/components/FilterModal'
import { DateRangeFilterWithPresets } from 'components/Filters/fields/DateRangeFilterWithPresets'
import { SelectFilter } from 'components/Filters/fields/SelectFilter'
import { useUserOptions } from 'services/users'

import { FilterIdentifier } from 'models/saved_view'
import { createFilterColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { ACTIVITY_V2_COLUMNS } from 'components/DataExpansionComponents/Activity/activityV2ColumnInfo'

const IDENTIFIER: FilterIdentifier = 'ACTIVITY_TABLE_V2'

export default function ActivityV2Filterset() {
  const { data: userOptions } = useUserOptions({ onlyActive: true })

  const activityFilterHelper = createFilterColumnHelper({
    columns: ACTIVITY_V2_COLUMNS,
  })
  const activityV2FilterStore = filterStoreRepo.getStore('ACTIVITY_TABLE_V2')

  return (
    <FilterModal identifier={IDENTIFIER} store={activityV2FilterStore}>
      <FilterGroup title="Activity">
        <SelectFilter
          {...activityFilterHelper.retrieveProps('user')}
          filterStore={activityV2FilterStore}
          options={userOptions as any}
        />
        <DateRangeFilterWithPresets
          {...activityFilterHelper.retrieveProps('created_at')}
          filterStore={activityV2FilterStore}
        />
        <SelectFilter
          {...activityFilterHelper.retrieveProps('event_type')}
          filterStore={activityV2FilterStore}
          options={[
            { value: 'contactcompany', label: 'Company' },
            { value: 'contact', label: 'Contact' },
            { value: 'deal', label: 'Deal' },
            { value: 'doorproxy', label: 'Door' },
          ]}
        />
      </FilterGroup>
    </FilterModal>
  )
}
